<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.client-group.dialog.title' | translate"
		id="client-group-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1">
						<ins-checkbox
							id="client-group-dialog-default"
							[(ngModel)]="viewModel.bo.model.isDefault"
							[label]="'scenes.configuration.shared.client-group.dialog.form.default.label' | translate"
							[sklValidate]="getValidationKey('isDefault')">
						</ins-checkbox>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.client-group.dialog.form.name.label' | translate">
							<ins-input
								id="client-group-dialog-name"
								[skl-focus-by]
								[(ngModel)]="viewModel.bo.model.name"
								[placeholder]="'scenes.configuration.shared.client-group.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="client-group-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			id="client-group-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>